// extracted by mini-css-extract-plugin
export default {"buttonText":"styles_buttonText__tcha2","input":"styles_input__mrcnV","text":"styles_text__4e4PL","icon":"styles_icon__Tk4iE","slide-in-bottom":"styles_slide-in-bottom__guats"};